import {
  ActionIcon,
  Button,
  CopyButton,
  Group,
  Menu,
  Tooltip,
  createStyles,
  rem,
} from "@mantine/core";
import { useClipboard } from "@mantine/hooks";
import {
  IconChevronDown,
  IconCopy,
  IconPlugConnectedX,
} from "@tabler/icons-react";
import { useWalletContext } from "../context/wallet";
import { walletProvider } from "../services/wallet";

const useStyles = createStyles((theme) => ({
  button: {
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
  },

  menuControl: {
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
    border: 0,
    borderLeft: `${rem(1)} solid ${
      theme.colorScheme === "dark" ? theme.colors.dark[7] : theme.white
    }`,
  },
}));

export const WalletConnectButton = () => {
  const { classes, theme } = useStyles();
  const { copied, copy } = useClipboard({ timeout: 500 });
  const menuIconColor =
    theme.colors[theme.primaryColor][theme.colorScheme === "dark" ? 5 : 6];

  const {
    connected,
    setOrdinalsPubkey,
    setPaymentPubkey,
    setOrdinalsAddress,
    setPaymentAddress,
    setOrdinalsAddressType,
    ordinalsAddress,
    multiSigWallet,
  } = useWalletContext();

  return (
    <>
      <Group noWrap spacing={0}>
        <Tooltip label="Address copied" opened={copied}>
          <Button
            className={connected ? classes.button : undefined}
            onClick={async () => {
              if (connected) {
                copy(ordinalsAddress);
                return;
              }
              try {
                const response = await walletProvider.connect();
                setOrdinalsPubkey(response.ordinalsPubkey);
                setPaymentPubkey(response.paymentPubkey);
                setOrdinalsAddress(response.ordinalsAddress);
                setPaymentAddress(response.paymentAddress);
                setOrdinalsAddressType(response.ordinalsAddressType);
              } catch (err) {
                console.error(err);
              }
            }}
          >
            {connected
              ? `${ordinalsAddress?.slice(0, 6)}...`
              : "Connect Wallet"}
          </Button>
        </Tooltip>
        {connected && (
          <Menu
            transitionProps={{ transition: "pop" }}
            position="bottom-end"
            withinPortal
          >
            <Menu.Target>
              <ActionIcon
                variant="filled"
                color={theme.primaryColor}
                size={36}
                className={classes.menuControl}
              >
                <IconChevronDown size="1rem" stroke={1.5} />
              </ActionIcon>
            </Menu.Target>
            <Menu.Dropdown>
              <Menu.Item
                icon={
                  <IconCopy size="1rem" stroke={1.5} color={menuIconColor} />
                }
              >
                <CopyButton value={multiSigWallet.data?.address ?? ""}>
                  {({ copy }) => (
                    <span onClick={copy}>Copy multisig wallet address</span>
                  )}
                </CopyButton>
              </Menu.Item>
              <Menu.Item
                icon={
                  <IconPlugConnectedX
                    size="1rem"
                    stroke={1.5}
                    color={menuIconColor}
                  />
                }
                onClick={() => {
                  setOrdinalsPubkey("");
                  setPaymentPubkey("");
                }}
              >
                Disconnect
              </Menu.Item>
            </Menu.Dropdown>
          </Menu>
        )}
      </Group>
    </>
  );
};
